import React from 'react';
import { useQuery, useMutation } from 'react-query';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, Text, Button, VStack, HStack, useToast, AlertDialog, AlertDialogBody, AlertDialogFooter, AlertDialogHeader, AlertDialogContent, AlertDialogOverlay } from '@chakra-ui/react';
import AuctionService from '../../services/AuctionService';
import CustomSpinner from './CustomSpinner';

const ViewWinners = () => {
  const { itemId } = useParams();
  const navigate = useNavigate();
  const toast = useToast();
  const [isOpen, setIsOpen] = React.useState(false);
  const [selectedAction, setSelectedAction] = React.useState(null);
  const [selectedWinnerId, setSelectedWinnerId] = React.useState(null);
  const onClose = () => setIsOpen(false);
  const cancelRef = React.useRef();

  const { data, isLoading, error } = useQuery(['winners', itemId], () => AuctionService.fetchWinnersOrLosers(itemId, 'winner'));

  const mutation = useMutation((params) => AuctionService.performAdminAction(params.winnerId, params.action), {
    onSuccess: () => {
      toast({
        title: 'Action performed successfully',
        status: 'success',
        duration: 3000,
        isClosable: true,
      });
      
      // Reload the page after the action is performed
      setTimeout(() => {
        window.location.reload(); // Reload the page after 3 seconds
      }, 1500); // Duration matches the toast duration
    },
    onError: () => {
      toast({
        title: 'Error performing action',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  });
  
  const handleAction = (action, winnerId) => {
    setSelectedAction(action);
    setSelectedWinnerId(winnerId);
    setIsOpen(true);
  };

  const confirmAction = () => {
    mutation.mutate({ winnerId: selectedWinnerId, action: selectedAction });
    setIsOpen(false);
  };

  if (isLoading) {
    return <CustomSpinner />;
  }

  if (error) {
    return <Box>Error loading winners.</Box>;
  }

  return (
    <Box maxW="5xl" mx="auto" p={4}>
      <Text fontSize="2xl" mb={4}>Winners</Text>
      {data.data.map((winner) => (
        <VStack key={winner._id} p={4} border="1px" borderColor="gray.200" borderRadius="md" align="start" spacing={4}>
          <Text><strong>User Name:</strong> {winner.userId.name}</Text>
          <Text><strong>Phone Number:</strong> {winner.userId.phoneNumber}</Text>
          <Text><strong>Amount:</strong> {winner.totalPaid}</Text>
          {/* <Text><strong>amount befor deposit:</strong> {winner?.totalPaid}</Text> */}
          {/* <Text><strong>payed from deposit :</strong> {winner?.paidFromDeposit?'true':"false"}</Text> */}
          <Text><strong>Status:</strong> {winner.status}</Text>
          <Text><strong>Actions:</strong> {winner?.statusadmin? winner?.statusadmin:"no action taken"}</Text>
          {winner?.statusadmin?"":   <HStack spacing={4}>
            <Button isLoading={mutation.isLoading } colorScheme="green" onClick={() => handleAction('approve', winner._id)}>Approve</Button>
            <Button colorScheme="yellow" onClick={() => handleAction('cancelled', winner._id)}>Cancel</Button>
            <Button colorScheme="red" onClick={() => handleAction('delete', winner._id)}>Delete</Button>
            <Button colorScheme="orange" onClick={() => handleAction('regected', winner._id)}>Reject</Button>
          </HStack>}
        </VStack>
      ))}

      <AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose}>
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Confirm Action
            </AlertDialogHeader>

            <AlertDialogBody>
              Are you sure you want to {selectedAction} this winner?
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onClose}>
                Cancel
              </Button>
              <Button colorScheme="red" onClick={confirmAction} ml={3}>
                Confirm
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </Box>
  );
};

export default ViewWinners;
